<template>
    <div>

        <v-dialog class="loading-dialog"
                  v-model="documentUploading"
                  persistent
                  overlay
                  max-width="450px">
            <v-card>
                <v-layout row pt-4 pb-4 pr-4 pl-4>
                    <v-flex xs12>
                        <v-card-title class="headline">Uploading {{this.fileName}}...</v-card-title>
                    </v-flex>
                    <v-flex justify-end>
                        <v-progress-circular
                                :size="70"
                                :width="7"
                                color="primary"
                                indeterminate
                        ></v-progress-circular>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-dialog>
        <v-text-field :loading="documentUploading" :label="label"
                      @click='pickFile'
                      v-model='fileName' prepend-icon='attach_file'></v-text-field>
        <input
                type="file"
                style="display: none"
                :ref="inputRef"
                :accept="inputAccept"
                @change="onFilePicked"
        >
    </div>
</template>

<script>
 
    import {
        Documents
    } from '../../store/namespace-helper'

     export default {
       name: 'v-upload-document-picker',
       model: {
         prop: 'document',
         event: 'change'
       },
       props: {
         document: {},
         label: {
           type: String,
           default: ''
         },
         inputRef: {
           type: String,
           default: 'pdf'
         },
         inputAccept: {
           type: String,
           default: '"application/pdf'
         }
       },
       data () {
         return {
           fileName: '',
           fileUrl: '',
           fileData: '',
           documentUploading: false
         }
       },
       created () {
       },
       computed: {
       },
       methods: {
         onFilePicked (e) {
           const files = e.target.files
           if (files[0] !== undefined) {
             this.fileName = files[0].name
             if (this.fileName.lastIndexOf('.') <= 0) {
               return
             }
             const fr = new FileReader()
             fr.readAsDataURL(files[0])
             fr.addEventListener('load', () => {
               this.fileUrl = fr.result
               this.fileData = files[0]
               this.uploadDocument()
             })
           } else {
             this.fileName = ''
             this.fileData = ''
             this.fileUrl = ''
           }
         },
         pickFile () {
           this.$refs[this.inputRef].click()
         },
         uploadDocument () {
           this.documentUploading = true
           this.$store.dispatch(Documents.actions.uploadDocument, {
             id: 0,
             documents_type_id: 2,
             documents_data: this.fileUrl
           }).then(response => {
             this.$emit('change', response.data.data)
             this.documentUploading = false
             this.fileName = ''
             this.fileData = ''
             this.fileUrl = ''
           }).catch(reason => {
             console.log(reason)
             this.documentUploading = false
             this.fileName = ''
             this.fileData = ''
             this.fileUrl = ''
           })
         }
       },
       watch: {
       }

     }
</script>



// WEBPACK FOOTER //
// src/components/Shared/UploadDocumentPicker.vue